$(".c-fancy-button").mousedown(function(e) {
    const button = $(this);
    e.preventDefault();

    if (button.hasClass('c-button--loading')) {
        return;
    }

    button.addClass('c-button--loading');
    button.find('.c-fancy-button__text').text(button.data('loadingLabel'));

    button.bind('animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd', function() {
        button.removeClass('active');
    });

    $.ajax({
        url: button.data('url'),
        method: 'GET'
    })
    .done((response) => {
        button.removeClass('c-button--loading');
        button.find('.c-fancy-button__text').text(response);
        button.addClass("active");
    })
    .fail(() => alert('Couldn\'t pick a winner'));
});



// WEBPACK FOOTER //
// ./src/js/components/pick-a-winner.js